<script>
    import { createEventDispatcher } from 'svelte';
    import Icon from '../icons/Icon.svelte';
    import TableCard from './TableCard.svelte';

    export let isLoading = false;
    export let hasLoadError = false;
    export let loadErrorMessage = '';
    export let filterStatus = 'all';
    export let filteredTables = [];

    const dispatch = createEventDispatcher();

    function handleRetry() {
        dispatch('retryLoad');
    }

    function handleCreateFirst() {
        dispatch('createFirstTable');
    }

    function handleResetFilter() {
        dispatch('resetFilter');
    }
</script>

{#if isLoading}
    <!-- ESTADO 1: Carregamento -->
    <div class="loading-state">
        <span class="spinner"><Icon name="refresh" size={24} className="spin" /></span>
        <p>Carregando mesas do salão...</p>
    </div>
{:else if hasLoadError && filteredTables.length === 0}
    <!-- ESTADO 4: Erro de API -->
    <div class="empty-filter-state error-state">
        <div class="empty-icon-wrap error"><Icon name="alert-circle" size={32} /></div>
        <h3>Não foi possível carregar as mesas</h3>
        <p>{loadErrorMessage || 'Ocorreu uma falha ao comunicar com o servidor. Verifique sua conexão e tente novamente.'}</p>
        <button class="btn-secondary-action" on:click={handleRetry}>
            <Icon name="refresh" size={14} />
            <span>Tentar Novamente</span>
        </button>
    </div>
{:else if filteredTables.length === 0}
    <!-- ESTADO 2: Sucesso + Nenhuma mesa cadastrada ou filtro vazio -->
    <div class="empty-filter-state">
        <div class="empty-icon-wrap"><Icon name="utensils" size={32} /></div>
        {#if filterStatus === 'all'}
            <h3>Nenhuma mesa cadastrada</h3>
            <p>Cadastre sua primeira mesa para iniciar os atendimentos no salão.</p>
            <button class="btn-primary" on:click={handleCreateFirst}>
                <Icon name="plus" size={15} /> Cadastrar Mesa 01
            </button>
        {:else}
            <h3>Nenhuma mesa com este filtro</h3>
            <p>Alterne para "Todas" para visualizar a visão geral do salão.</p>
            <button class="btn-secondary-action" on:click={handleResetFilter}>
                Ver Todas as Mesas
            </button>
        {/if}
    </div>
{:else}
    <div class="tables-grid">
        {#each filteredTables as table (table.id)}
            <TableCard
                {table}
                on:openTable
                on:deleteTable
                on:viewComanda
                on:closeTable
            />
        {/each}
    </div>
{/if}

<style>
    .tables-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(265px, 1fr));
        gap: 16px;
    }

    .loading-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px;
        gap: 14px;
        color: #64748B;
    }

    .spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FF6A00;
    }

    :global(.spin) {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    .empty-filter-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        border: 1px dashed var(--neutral-border, #CBD5E1);
        border-radius: var(--radius-lg, 16px);
        padding: 60px 24px;
        text-align: center;
        color: var(--text-secondary, #64748B);
    }

    .empty-icon-wrap {
        width: 64px;
        height: 64px;
        background: var(--brand-primary-soft, #FFF7ED);
        color: var(--brand-primary, #FF6A00);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
    }

    .empty-icon-wrap.error {
        background: #FEF2F2;
        color: #DC2626;
    }

    .empty-filter-state h3 {
        margin: 0 0 8px 0;
        font-size: 18px;
        font-weight: 800;
        color: var(--text-primary, #0F172A);
    }

    .empty-filter-state p {
        margin: 0 0 20px 0;
        font-size: 14px;
        max-width: 400px;
        line-height: 1.5;
    }

    .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 18px;
        background: #FF6A00;
        border: 1.5px solid #FF6A00;
        border-radius: 8px;
        font-size: 13.5px;
        font-weight: 800;
        color: #FFFFFF;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
        transition: all 0.2s ease;
    }

    .btn-primary:hover {
        background: #E65F00;
        border-color: #E65F00;
        box-shadow: 0 4px 8px rgba(255, 106, 0, 0.3);
    }

    .btn-secondary-action {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 9px 16px;
        background: #FFFFFF;
        border: 1.5px solid #CBD5E1;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        color: #334155;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-secondary-action:hover {
        background: #F8FAFC;
        border-color: #94A3B8;
        color: #0F172A;
    }

    @media (max-width: 767.98px) {
        .tables-grid {
            display: grid !important;
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 8px !important;
        }
    }
</style>
